import React, { useState } from 'react';
import {Form, Input, Button, message, Row, Col, Select} from 'antd';
import {MailOutlined, UserOutlined, MessageOutlined, PlusOutlined} from '@ant-design/icons';
import {Flex} from "rebass";
import axios from "axios";
import {useWindowDimensions} from "../../contexts/WindowDimensionsContext";
import PageTitle from "../../components/PageTitle";

const ContactForm = ({ backendApiUrl }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const windowDimensions = useWindowDimensions();

    const onFinish = async (values) => {
        setLoading(true);
        messageApi
            .open({
                type: 'loading',
                content: 'Envoi du message...',
            })
        try {
            const response = await axios.post(`${backendApiUrl}/contact-us`, {values}, {
                headers: { "Content-Type": "application/json" },
            });
            if (response.status === 200)
                message.success("Votre message a été envoyé !");
            else
                message.error("Une erreur s'est produite. Veuillez réessayer.");
            form.resetFields();
        } catch (error) {
            message.error("Une erreur s'est produite. Veuillez réessayer.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Flex flexDirection={"column"} justifyContent={"center"} style={{ marginBottom: "auto" }}>
            {contextHolder}
            <PageTitle title={"Nous contacter"}></PageTitle>
            <p className={"my-5 max-w-[800px] mx-auto text-center"}>
                Si vous rencontrez un bug, avez des suggestions d'amélioration, ou souhaitez poser toute autre question concernant nos services, n'hésitez pas à nous contacter en remplissant le formulaire ci-dessous.
                Nous vous répondrons dans les plus brefs délais pour résoudre vos problèmes ou écouter vos suggestions.
            </p>
            <Row justify="center" className={"mt-3"}>
                <Col xs={24} sm={20} md={16} lg={12}>
                    <Form
                        form={form}
                        name="contact-form"
                        layout="vertical"
                        onFinish={onFinish}
                        style={{ maxWidth: '100%', margin: 'auto' }}
                    >
                        <Form.Item
                            name="name"
                            label="Nom"
                            rules={[
                                { required: true, message: "Veuillez renseigner votre nom" },
                                { min: 2, message: "Le nom doit être composé d'au moins deux caractères" }
                            ]}
                        >
                            <Input
                                prefix={<UserOutlined />}
                                placeholder="Votre nom"
                                style={{fontSize: windowDimensions.wWCheck(500) ? "" : "16px"}}
                            />
                        </Form.Item>

                        <Form.Item
                            name="email"
                            label="Email"
                            rules={[
                                { required: true, message: "Veuillez renseigner votre email" },
                                { type: "email", message: "Veuillez renseigner un email valide" }
                            ]}
                        >
                            <Input
                                prefix={<MailOutlined />}
                                placeholder="Votre email"
                                style={{fontSize: windowDimensions.wWCheck(500) ? "" : "16px",}}
                            />
                        </Form.Item>

                        <Form.Item
                            name="sujet"
                            label="Sujet"
                            rules={[{ required: true, message: "Veuillez renseigner le sujet" }]}
                        >
                            <Input
                                prefix={<MessageOutlined />}
                                placeholder="Sujet"
                                style={{fontSize: windowDimensions.wWCheck(500) ? "" : "16px",}}
                            />
                        </Form.Item>

                        <Form.Item
                            name="message"
                            label="Message"
                            rules={[
                                { required: true, message: "Veuillez renseigner votre message" },
                            ]}
                        >
                            <Input.TextArea
                                rows={8}
                                placeholder="Votre message"
                                style={{fontSize: windowDimensions.wWCheck(500) ? "" : "16px",}}
                            />
                        </Form.Item>

                        <Form.Item style={{display: "flex", justifyContent: "center", width: "100%"}}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                            >
                                Envoyer le message
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Flex>
    );
};

export default ContactForm;
